import { Routes } from '@angular/router';
import { authGuard } from './core/auth/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/auth/pages/landing/landing.component').then(
        (m) => m.LandingComponent,
      ),
  },
  {
    path: 'how-it-works',
    loadComponent: () =>
      import('./features/auth/pages/how-gulu-works/how-gulu-works.component').then(
        (m) => m.HowGuluWorksComponent,
      ),
  },
  {
    path: 'howguluworks',
    redirectTo: 'how-it-works',
    pathMatch: 'full',
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./features/auth/pages/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent,
      ),
  },
  {
    path: 'privacy',
    redirectTo: 'privacy-policy',
    pathMatch: 'full',
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./features/auth/pages/terms-of-service/terms-of-service.component').then(
        (m) => m.TermsOfServiceComponent,
      ),
  },
  {
    path: 'terms',
    redirectTo: 'terms-of-service',
    pathMatch: 'full',
  },
  {
    path: 'landing2',
    loadComponent: () =>
      import('./features/auth/pages/landing-page-second/landingpagesecond.component').then(
        (m) => m.LandingPageSecondComponent,
      ),
  },
  {
    path: 'creatorprofilesecond',
    redirectTo: 'profile-second',
    pathMatch: 'full',
  },
  {
    path: 'creator-profile-second',
    redirectTo: 'profile-second',
    pathMatch: 'full',
  },
  {
    path: 'profile-second',
    loadComponent: () =>
      import('./shared/components/profile/creator-profile-second/creatorprofilesecond.component').then(
        (m) => m.Creatorprofilesecondcomponent,
      ),
  },
  {
    path: 'profile-round',
    loadComponent: () =>
      import('./shared/components/profile/creator-profile-second').then(
        (m) => m.ProfileRoundPageComponent,
      ),
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'creator',
    canActivate: [authGuard],
    loadChildren: () => import('./features/creator/creator.routes').then((m) => m.creatorRoutes),
  },
  {
    path: 'brand',
    canActivate: [authGuard],
    loadChildren: () => import('./features/brand/brand.routes').then((m) => m.brandRoutes),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/notifications/pages/notifications-page.component').then(
        (m) => m.NotificationsPageComponent,
      ),
  },
  {
    path: 'brand-profile/:id',
    loadComponent: () =>
      import('./features/brand/public-profile/brand-public-profile-view/brand-public-profile-view.component').then(
        (m) => m.BrandPublicProfileViewComponent,
      ),
  },
  {
    // Renamed from 'creator/:creatorId', which was unreachable: the earlier
    // { path: 'creator' } entry matches the 'creator' segment first and delegates the
    // remainder to creatorRoutes (which has no :creatorId child). This mirrors the
    // 'brand-profile/:id' convention above and, like it, is intentionally public.
    path: 'creator-profile/:creatorId',
    loadComponent: () =>
      import('./features/creator/public-profile/creator-public-profile-view/creator-public-profile-view.component').then(
        (m) => m.CreatorPublicProfileViewComponent,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
